export const URL_CEEMAS_VALIDATION =
  "/gy-enablement/ceemas-mot-validation/:filterDetails";
export const URL_MANUAL_ADJUSTMENT = "/gy-enablement/mot-manual-adjustment";
export const URL_TAX_PLANT_REGISTRY =
  "/gy-enablement/master/tax-plant-registry";
export const URL_NETS_CO2_COST = "/gy-enablement/master/NETS-CO2-Costs";
export const URL_COPRO_SPAIN = "/config-center/coprocessing-spain";

export default URL_CEEMAS_VALIDATION;
